import axios from 'axios';
import epochToIso from '@/util/epochToIso.js';


  // stays on AGO: the permit application status data has no databridge table (probed
  // under several names, 2026-09-18) - ask CityGeo to land it, then this moves
  const permitApplicationAxios = axios.create({
    baseURL: 'https://services.arcgis.com/fLeGjb7u4uXqeF9q/ArcGIS/rest/services/'
  });
  const permitApp_URL = 'AGO_Lyr_Permit_App_Status_Eclipse/FeatureServer/0/query';
  // const permitApp_URL = 'PermitAppStatusEclipse/FeatureServer/0/query';


  const permitAppParams = function(id) {
      return {
          where: "APPLICATIONNUMBER = '" + id + "'",
          returnGeometry: false,
          returnZ: false,
          returnM: false,
          outFields: '*',
          f: 'pjson',
      }
  };

const state = () => ({
    permitApps: [],
});

const mutations = {
    setPermitApps(state, data) {
        let dataArray = [];
        if (data) {
            Object.values(data).forEach((x => {
                const attrs = x.attributes;
                attrs.APPLICATIONDATE = epochToIso(attrs.APPLICATIONDATE);
                attrs.LATESTREVIEWDUEDATE = epochToIso(attrs.LATESTREVIEWDUEDATE);
                attrs.LATESTREVIEWCOMPLETEDDATE = epochToIso(attrs.LATESTREVIEWCOMPLETEDDATE);
                dataArray.push(attrs);
                }));
            return state.permitApps = dataArray;
        } else {
            return state.permitApps = null;
        }
    },
};  

const actions = {
    async getPermitApps({ commit, dispatch }, params) {
        dispatch;
        try {
            // console.log("getPermitAppss: ", query);
            let response = await permitApplicationAxios.get(permitApp_URL, { params: permitAppParams(params) });
            commit('setPermitApps', { ...response.data.features });
            console.log("Permits response: ", response)
            let permitArray = []; 
            response.data.features.forEach( a => permitArray.push("'"+a.attributes.PERMITNUMBER+"'"))
        } catch (err) {
            throw new Error(err)
        } 
      },
};




export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };